import axios from "axios";

import config from "../config";

export default class PaymentService {
  static createOrder = (mobile, paymentPackage) => {
    return axios.put(`${config.baseUrl}/user/${mobile}/order`, {
      package: paymentPackage,
    });
  };

  static verifyPayment = (
    mobile,
    order_id,
    razerpay_order_id,
    razorpay_payment_id,
    razorpay_signature
  ) => {
    return axios.post(
      `${config.baseUrl}/user/${mobile}/order/${order_id}/verify`,
      {
        razerpay_order_id: razerpay_order_id,
        razorpay_signature: razorpay_signature,
        razorpay_payment_id: razorpay_payment_id,
      }
    );
  };

  // gtag('set', {'user_id': 'USER_ID'});
}
